import { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useHTTP } from 'hooks/useRequest';
import useErrorPush from '../../utils/useErrorPush';

const PaymentAccount = ({
  showPaymentDisplayError,
  paymentDisplayErrors,
  paymentTotal,
  setPaymentStatus,
  completeAccountOrderUrl,
  showDetailErrors,
  configGenericError,
  toggleGenericError,
  completeOrder,
}) => {
  const [disableBtn, setDisableBtn] = useState(false);

  const [completeAccountOrder, setCompleteAccountOrder] = useState(false);

  const accountOrderRequestConfig = {
    method: 'POST',
    url: completeAccountOrder ? completeAccountOrderUrl : null,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };

  const { data, error } = useHTTP(accountOrderRequestConfig || null);

  useEffect(() => {
    if (data?.success) {
      showDetailErrors(false, []);
      completeOrder({ url: data.order_url });
      setPaymentStatus(false);
    }
  }, [data]);

  useEffect(() => {
    if (typeof error === 'undefined') return;
    configGenericError({
      title: 'Error',
      body: (
        <div>
          <p>Unfortunately something has gone wrong.</p>
          <p>
            We are sorry for any inconvenience this may cause. Please try again
            later. If the problem persists, please contact our customer service
            team.
          </p>
        </div>
      ),
      errorButton: true,
      errorButtonTitle: 'Refresh Checkout',
      errorButtonAction: toggleGenericError,
      closeAction: toggleGenericError,
      reloadCheckoutAfterClose: true,
      reloadCheckoutAfterErrorButtonAction: true,
    });
    setPaymentStatus(false);
    setDisableBtn(true);

    useErrorPush('Checkout: Pay On Account error', window.dataLayer);
  }, [error]);

  return (
    <div className="checkout-sub-panel payment">
      <div className="paypal-payment-summary no-top-margin">
        Your Account will be charged <strong>&pound;{paymentTotal}</strong> for
        your delivery items and delivery charge (if applicable).
      </div>

      {showPaymentDisplayError && (
        <div className="showPaymentDisplayError">
          {paymentDisplayErrors.map(errorMessage => (
            <p key={uuidv4()}>{errorMessage}</p>
          ))}
        </div>
      )}

      <div className="fl-on fl-sm-on">
        <button
          type="button"
          onClick={() => {
            setDisableBtn(true);
            setPaymentStatus(true);
            setCompleteAccountOrder(true);
          }}
          className="pay-on-account-button next-panel ff-body fw-600"
          disabled={disableBtn}>
          Complete Order
        </button>
      </div>
    </div>
  );
};

export default PaymentAccount;
